import request from '@/utils/request'

export function getProductList() {
  return request.get('/product/list')
}
